import PageAlert from './PageAlert.jsx'

export default PageAlert
